import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { Icon, IconStack } from 'js/components';

import { faFluxCapacitor } from '@fortawesome/pro-solid-svg-icons';
import { faQuestion } from '@fortawesome/pro-regular-svg-icons';

function ManagedProductCapabilities({ managedProduct }) {
  return (
    <Card>
      <CardBody>
        <div className="media text-muted mt-4 mb-4">
          <IconStack size="4x" fixedWidth className="mr-3">
            <Icon icon={faFluxCapacitor} />
            <Icon
              icon={faQuestion}
              transform="shrink-10 right-9 up-9 rotate-12"
            />
          </IconStack>
          <div className="media-body">
            <p>This managed product isn't associated with any capabilities.</p>
            <p>
              Add a managed product to a user group from that group's settings.
              You will be able to see all the capabilities a managed product is
              associated with through their connection to user groups
            </p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default ManagedProductCapabilities;
